export default __webpack_public_path__ + "static/media/banner-460x200-bg-orange-template.aecd0dab.svg";